

export default {

    name: 'projects',
    component: () => import('../../../layouts/ProjectsLayout.vue'),
    children: [
        {
            path: '',
            name: 'projectsView',
            component: () => import('@/modules/projectListModule/views/ProjectsView.vue'),
            meta : {requiresAuth : true, allowedUserTypes: [ 1, 2, 3 ]}
        },
        // {
        //     path: ':id',
        //     name: 'entry',
        //     component: () => import('@/modules/projects/views/EntryView'),
        //     props: ( route ) => {
        //         return {
        //             id: route.params.id
        //         }
        //     }
        // }
    ]


}